import React from 'react';
import styled from 'styled-components';
import StyleConfig from 'src/constants/StyleConfig';

type Props = {
  id: string;
  onChange: Function;
  multiple?: boolean;
};

const InputFileButton = ({ ...props }: Props) => {
  return (
    <Styled>
      <label htmlFor={props.id}>
        画像をアップロードしてください
        <input
          id={props.id}
          type="file"
          accept={'image/*'}
          multiple={props.multiple}
          onChange={(e) => {
            props.onChange(e);
          }}
        />
      </label>
    </Styled>
  );
};

type StyledProps = {};

const Styled = styled.div<StyledProps>`
  box-sizing: border-box;
  text-align: center;
  > label {
    position: relative;
    padding: 12px;
    font-size: 12px;
    display: inline-block;
    color: ${StyleConfig.COLOR.TEXT_COLOR};
    border: 1px solid ${StyleConfig.COLOR.TEXT_COLOR};
    background: #fff;
    input {
      display: none;
    }
  }
`;

export default InputFileButton;
